export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
export const SET_REPORT = 'SET_REPORT'
export const SET_REPORT_SUMMARY = 'SET_REPORT_SUMMARY'
export const SET_REPORT_DETAILS = 'SET_REPORT_DETAILS'
export const SET_PAYOUT_REPORT = 'SET_PAYOUT_REPORT'
export const SET_PAYMENT_SUMMARY = 'SET_PAYMENT_SUMMARY'
export const GET_ALL_REPORT_DISPLAY = 'GET_ALL_REPORT_DISPLAY'
